/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDependantRequest } from './AssetDependantRequest';
import {
    AssetDependantRequestFromJSON,
    AssetDependantRequestFromJSONTyped,
    AssetDependantRequestToJSON,
    AssetDependantRequestToJSONTyped,
} from './AssetDependantRequest';

/**
 * 
 * @export
 * @interface SaveAssetDependantsRequest
 */
export interface SaveAssetDependantsRequest {
    /**
     * 
     * @type {Array<AssetDependantRequest>}
     * @memberof SaveAssetDependantsRequest
     */
    dependants: Array<AssetDependantRequest>;
}

/**
 * Check if a given object implements the SaveAssetDependantsRequest interface.
 */
export function instanceOfSaveAssetDependantsRequest(value: object): value is SaveAssetDependantsRequest {
    if (!('dependants' in value) || value['dependants'] === undefined) return false;
    return true;
}

export function SaveAssetDependantsRequestFromJSON(json: any): SaveAssetDependantsRequest {
    return SaveAssetDependantsRequestFromJSONTyped(json, false);
}

export function SaveAssetDependantsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetDependantsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dependants': ((json['dependants'] as Array<any>).map(AssetDependantRequestFromJSON)),
    };
}

export function SaveAssetDependantsRequestToJSON(json: any): SaveAssetDependantsRequest {
    return SaveAssetDependantsRequestToJSONTyped(json, false);
}

export function SaveAssetDependantsRequestToJSONTyped(value?: SaveAssetDependantsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dependants': ((value['dependants'] as Array<any>).map(AssetDependantRequestToJSON)),
    };
}

